import {
  Entity,
  PrimaryGeneratedColumn,
  Column,
  CreateDateColumn,
  UpdateDateColumn,
  ManyToOne,
  JoinColumn,
} from 'typeorm';
import { IsOptional, IsInt } from 'class-validator';
import { HistoricoPergunta } from './HistoricoPergunta';
import { Historico } from './Historico';
import { Usuario } from './Usuario';

@Entity({ name: 'historicos_respostas' })
export class HistoricoResposta {
  @PrimaryGeneratedColumn()
  @IsOptional()
  @IsInt()
  id?: number;

  @Column()
  historico_id: number;

  @Column()
  historico_pergunta_id: number;

  @Column()
  @IsOptional()
  resposta: string | null;

  @Column()
  @IsOptional()
  observacoes: string | null;

  @Column()
  versao: number;

  @CreateDateColumn()
  @IsOptional()
  created?: Date;

  @Column()
  @IsOptional()
  created_by?: number | null;

  @UpdateDateColumn()
  @IsOptional()
  updated?: Date;

  @Column()
  @IsOptional()
  updated_by?: number | null;

  // RELATIONS
  @ManyToOne(
    () => HistoricoPergunta,
    (historico_pergunta) => historico_pergunta.historicos_respostas,
    {
      eager: true,
    },
  )
  @JoinColumn({ name: 'historico_pergunta_id' })
  historico_pergunta?: HistoricoPergunta;

  @ManyToOne(() => Historico, (historico) => historico.historicos_respostas)
  @JoinColumn({ name: 'historico_id' })
  historico?: Historico;

  @ManyToOne(() => Usuario)
  @JoinColumn({ name: 'created_by' })
  usuario_created_by?: Usuario;

  @ManyToOne(() => Usuario, {
    eager: true,
  })
  @JoinColumn({ name: 'updated_by' })
  usuario_updated_by?: Usuario;
}
